/**
* author: duxin
* date: 2020/4/7
* describe:
*/

<template>
	<div class="service-chunk">
		<h1 class="p1">{{$t("home.services")}}</h1>
		<div class="content-wrap">
			<template v-for="(item,index) in serviceList">
				<RouterLink :to="item.href" class="block" :key="index">
					<i :class="item.icon" class="iconfont"></i>
					<h3 class="block-title">{{item.title}}</h3>
				</RouterLink>
			</template>
		</div>
	</div>
</template>

<script>
export default {
	name: 'me-service-chunk',
	data() {
		return {
			transitionName: '',
			serviceList: [
				{
					icon: 'iconshujuguanli',
					title: this.$t('menu.dm'),
					href: '/service/dm',
				},
				{
					icon: 'iconshengwutongji',
					title: this.$t('menu.biostatistics'),
					href: '/service/biostatistics',
				},
				{
					icon: 'icontongjibiancheng',
					title: this.$t('menu.sp'),
					href: '/service/sp',
				},
				// {
				// 	icon: 'iconyaowujingjie',
				// 	title: this.$t('menu.pharmacovigilance'),
				// 	href: '/service/pharmacovigilance',
				// },
				// {
				// 	icon: 'iconhujiaozhongxin',
				// 	title: this.$t('menu.cc'),
				// 	href: '/service/cc',
				// },
			],
		}
	},
}
</script>

<style lang="less" scoped>
@import './chunk';
@import '../../../style/constant';

.service-chunk {
	width: @page-width;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	padding: 80px 0;
	h1 {
		text-align: left;
	}
	.content-wrap {
		margin: 40px 0 0;
		display: flex;
		align-items: center;
		justify-content: space-around;
		a {
			text-decoration: none;
		}
		.block {
			width: calc(100% / 5);
			height: 280px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			background: #fff;
			position: relative;
			border: 1px solid transparent;
			.iconfont {
				color: @primary-color;
				font-size: 70px;
				line-height: 70px;
			}
			.block-title {
				font-weight: 400;
				color: @h2-color;
				margin-top: 20px;
			}

			&:hover {
				cursor: pointer;
				border: 1px solid @primary-color;
				box-shadow: 0px 0px 30px rgba(42, 105, 239, 0.16);
			}
			&:not(:last-child)::after {
				content: ' ';
				width: 2px;
				height: 30%;
				position: absolute;
				right: 0px;
				background: #d7d9e6;
			}
		}
	}
}

@media screen and (min-width: 320px) and (max-width: 480px) {
	.service-chunk {
		width: 90%;
		padding: 60px 0px 20px;
		.content-wrap {
			grid-template-columns: repeat(2, 50%);
			margin: 20px 0px 20px;
			display: flex;
			flex-wrap: wrap;
			justify-content: inherit;
			.block {
				width: 49%;
				height: 200px;
				&:nth-child(even)::after {
					content: ' ';
					width: 0px;
					height: 30%;
					position: absolute;
					right: 0px;
					background: #d7d9e6;
				}
				&:not(:last-child)::after {
					height: 80%;
				}
				.block-title {
					font-size: 16px;
				}
			}
		}
	}
}
</style>